import { pages } from '../../../config/routes';
import LinkButton from '../../link-button';
import copy from '../../../copy.json'
import './styles.scss'

const CLASS_NAME = 'banner';
const bannerCopy = copy.home.banner;

const BannerText = () => {
    return <div className={`${CLASS_NAME}-text`}>
        <h1 className={`${CLASS_NAME}-text-primary`}>{bannerCopy.header.primaryText}</h1>
        <h2>{bannerCopy.header.secondaryText}</h2>
        <div className={`${CLASS_NAME}-buttons`}>
            <LinkButton type="primary" text={bannerCopy.buttons.primaryButton} path={pages.contact} />
            <LinkButton type="secondary" text={bannerCopy.buttons.secondaryButton} path={pages.whyKeyes2Safety} />
        </div>
    </div>
}

const Banner = () => {
    return <header className={CLASS_NAME}>
        <div className={`${CLASS_NAME}-image`} data-testid="banner-image">
            <BannerText />
        </div>
    </header>
}

export default Banner;